<template>
  <v-list two-line subheader>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>Title</v-list-item-subtitle>
        <v-list-item-title>{{ doc.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>Category</v-list-item-subtitle>
        <v-list-item-title>{{ doc.categories }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>Description</v-list-item-subtitle>
        <v-list-item-title>{{ doc.description }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>Steps</v-list-item-subtitle>
        <ul>
          <li v-for="(chip, index) in doc.subitems" :key="`show-${index}`">
            {{ chip }}
          </li>
        </ul>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "UserServiceShowUser",
  data() {
    return {
      doc: this.value,
    };
  },
  props: {
    value: Object,
  },
};
</script>
